export const onLoading = () => {
  addClassesToHTML();
  addTargetBlank();
  addVHValue();
  limitAboutColumns();
};

const addClassesToHTML = () => {
  const isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints > 0;
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iP(ad|hone)/i);
  const webkit = !!ua.match(/WebKit/i);
  const isiOS = iOS && webkit && !ua.match(/CriOS/i);
  const touch = isTouch ? "touch" : "no-touch";
  const os = isiOS ? "ios" : "no-ios";
  document.documentElement.classList.remove("touch", "no-touch", "ios", "no-ios");
  document.documentElement.classList.add(touch, os);
};

const addTargetBlank = () => {
  const links = document.querySelectorAll("a");
  links.forEach((link) => {
    if (link.target) {
      return;
    } else if (link.host !== window.location.host) {
      link.target = "_blank";
      link.rel = "noopener";
    } else {
      link.target = "_self";
    }
  });
};

const addVHValue = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);

  const hh = document.querySelector('nav').scrollHeight;
  document.documentElement.style.setProperty("--hh", `${hh}px`);

  window.addEventListener("resize", () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    const hh = document.querySelector('nav').scrollHeight;
    document.documentElement.style.setProperty("--hh", `${hh}px`);
  });

};

// À propos (desktop) : le texte remplit 2 colonnes à la hauteur du portrait.
// S'il déborde sur une 3e colonne, on passe en 2 colonnes équilibrées.
const limitAboutColumns = () => {
  const text = document.querySelector('.about-text');
  if (!text) return;

  const check = () => {
    text.classList.remove('is-long');
    if (text.scrollWidth > text.clientWidth + 1) text.classList.add('is-long');
  };

  check();
  document.fonts.ready.then(check);
  window.addEventListener('load', check);
  window.addEventListener('resize', check);
};
